import { render, staticRenderFns } from "./DatatableTools.vue?vue&type=template&id=71640ba7&scoped=true"
import script from "./DatatableTools.vue?vue&type=script&lang=js"
export * from "./DatatableTools.vue?vue&type=script&lang=js"
import style0 from "./DatatableTools.vue?vue&type=style&index=0&id=71640ba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71640ba7",
  null
  
)

export default component.exports